/**
 * useSkipsPermissionChecks
 *
 * True when the signed-in user passes permission checks without holding the grant: a Super Admin
 * primary role, or AIG staff (skipsPermissionChecks in @aiga/app-config/permissions). Admin holds
 * what its grants say. The API's permission middleware and in-handler checks use the same helper,
 * so a screen never shows what the server would refuse (docs/SECURITY.md "Who skips permission
 * checks"). Not an admin-role test: use useAuth().isAdmin() for role gates.
 */
import { skipsPermissionChecks } from '@aiga/app-config/permissions';
import { useAuth } from '../contexts/AuthContext';

export function useSkipsPermissionChecks(): boolean {
  const { user, role } = useAuth();
  return skipsPermissionChecks({ role: role?.name, email: user?.email, isAdmin: user?.isAdmin });
}
